<template>
  <ts-loading-banner :loading="loading">
    <Table
      :data="resources"
      :columns="columns"
      size="small"
      highlight-row
      stripe
      max-height="700"
    >
      <template slot-scope="{ row }" slot="branchName">
        {{ row.customer.branch ? row.customer.branch.branch_name_en : '' }}
      </template>
      <template slot-scope="{ row }" slot="customerName">
        {{ row.customer.customer_name }}
      </template>
      <template slot-scope="{ row }" slot="customerType">
        {{ row.customer.type ? row.customer.type.customer_type : '' }}
      </template>
      <template slot-scope="{ row }" slot="dealerGrade">
        {{ row.customer.dealer_grade ? row.customer.dealer_grade.grade : '' }}
      </template>
      <template slot-scope="{ row }" slot="saleName">
        {{ row.customer.sale ? row.customer.sale.name : '' }}
      </template>
      <template slot-scope="{ row }" slot="disable">
        <span class="badge badge-success" v-if="!row.disable">Yes</span>
        <span class="badge badge-danger" v-else>No</span>
      </template>
      <template slot-scope="{ row }" slot="action">
        <a href="#" class="mr-2 text-info" @click.prevent="showModal(row)">
          <i class="fa fa-lock"></i>
        </a>
      </template>
    </Table>
    <div class="d-flex justify-content-between align-items-center p-15">
      <ts-total-list v-model="pagination" />
      <ts-pagination v-model="pagination" @navigate="fetchData"></ts-pagination>
    </div>
    <a-modal
      v-model="visible_add_new"
      :title="$t('customerUser.addNewCustomer')"
      @ok="onAddNew"
      @cancel="closeModal"
      width="20%"
      :okText="$t('add_new')"
      :confirmLoading="waiting"
      :cancelText="$t('cancel')"
      :maskClosable="false"
    >
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('customerUser.customer') }}
            </label>
            <a-select
              v-model="model.customer_id"
              :options="customers"
              allowClear
              show-search
              option-filter-prop="children"
              class="ts-w-full"
              :class="{ 'is-invalid': errors.has('customer_id') }"
              placeholder="Select"
              @change="onChangeCustomer"
              @search="handleSearchCustomer"
              :loading="customer_searching"
            ></a-select>
            <div class="invalid-feedback" v-if="errors.has('customer_id')">
              {{ errors.first('customer_id') }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('customerUser.userName') }}
            </label>
            <input
              v-model.trim="model.user_name"
              type="text"
              class="form-control"
              :class="{ 'is-invalid': errors.has('user_name') }"
            />
            <div class="invalid-feedback" v-if="errors.has('user_name')">
              {{ errors.first('user_name') }}
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('customerUser.password') }}
            </label>
            <div class="ts-relative">
              <input
                v-model="model.new_password"
                :type="show_new_password ? 'text' : 'password'"
                class="form-control pr-5 password"
                :class="{ 'is-invalid': errors.has('new_password') }"
              />
              <span
                class="password-icon"
                @click="() => (show_new_password = !show_new_password)"
              >
                <i
                  :class="show_new_password ? 'fas fa-eye-slash' : 'fas fa-eye'"
                ></i>
              </span>
              <div class="invalid-feedback" v-if="errors.has('new_password')">
                {{ errors.first('new_password') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('customerUser.confirm') }}
            </label>
            <div class="ts-relative">
              <input
                v-model="model.password_confirmation"
                :type="show_password_confirmation ? 'text' : 'password'"
                class="form-control pr-5 password"
                :class="{ 'is-invalid': errors.has('password_confirmation') }"
              />
              <span
                class="password-icon"
                @click="
                  () =>
                    (show_password_confirmation = !show_password_confirmation)
                "
              >
                <i
                  :class="
                    show_password_confirmation
                      ? 'fas fa-eye-slash'
                      : 'fas fa-eye'
                  "
                ></i>
              </span>
              <div
                class="invalid-feedback"
                v-if="errors.has('password_confirmation')"
              >
                {{ errors.first('password_confirmation') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
    <a-modal
      v-model="visible_resetpwd"
      :title="$t('customerUser.resetPassword')"
      @ok="handleOk"
      @cancel="closeModal"
      width="20%"
      :okText="$t('save')"
      :confirmLoading="waiting"
      :cancelText="$t('cancel')"
      :maskClosable="false"
    >
      <div class="ts-space-y-3">
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('customerUser.password') }}
            </label>
            <div class="ts-relative">
              <input
                v-model="model.new_password"
                :type="show_new_password ? 'text' : 'password'"
                class="form-control pr-5 password"
                :class="{ 'is-invalid': errors.has('new_password') }"
              />
              <span
                class="password-icon"
                @click="() => (show_new_password = !show_new_password)"
              >
                <i
                  :class="show_new_password ? 'fas fa-eye-slash' : 'fas fa-eye'"
                ></i>
              </span>
              <div class="invalid-feedback" v-if="errors.has('new_password')">
                {{ errors.first('new_password') }}
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <label class="required ts-text-xs">
              {{ $t('customerUser.confirm') }}
            </label>
            <div class="ts-relative">
              <input
                v-model="model.password_confirmation"
                :type="show_password_confirmation ? 'text' : 'password'"
                class="form-control pr-5 password"
                :class="{ 'is-invalid': errors.has('password_confirmation') }"
              />
              <span
                class="password-icon"
                @click="
                  () =>
                    (show_password_confirmation = !show_password_confirmation)
                "
              >
                <i
                  :class="
                    show_password_confirmation
                      ? 'fas fa-eye-slash'
                      : 'fas fa-eye'
                  "
                ></i>
              </span>
              <div
                class="invalid-feedback"
                v-if="errors.has('password_confirmation')"
              >
                {{ errors.first('password_confirmation') }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </a-modal>
  </ts-loading-banner>
</template>

<script>
import { Errors } from 'form-backend-validation'
import { mapState } from 'vuex'
import { debounce } from 'lodash'
export default {
  name: 'userIndex',
  data() {
    return {
      numeric: 1,
      show_new_password: false,
      show_password_confirmation: false,
      visible_resetpwd: false,
      visible_add_new: false,
      customer_searching: false,
      loading: false,
      errors: new Errors(),
      waiting: false,
      user_type: 1,
      model: {
        user_id: 0,
        customer_id: null,
        user_name: null,
        new_password: null,
        password_confirmation: null
      }
    }
  },
  computed: {
    ...mapState('security/customerUser', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.security.customerUser.search
      },
      set(newValue) {
        this.$store.commit('security/customerUser/SET_SEARCH', newValue)
        this.$store.commit('security/customerUser/RESET_CURRENT_PAGE')
      }
    },
    customers() {
      if (this.$store.state.security.customerUser.formViewDatas['customers']) {
        return this.$store.state.security.customerUser.formViewDatas[
          'customers'
        ].map(el => ({
          value: el.customer_id,
          label:
            el.customer_name +
            (el.contact_number ? '|' + el.contact_number : ''),
          contact_number: el.contact_number
        }))
      }
      return []
    },
    columns() {
      return [
        {
          title: this.$t('customerUser.branchName'),
          slot: 'branchName'
        },
        {
          title: this.$t('customerUser.customerName'),
          slot: 'customerName'
        },
        {
          title: this.$t('customerUser.userName'),
          key: 'user_name'
        },
        {
          title: this.$t('customerUser.type'),
          slot: 'customerType'
        },
        {
          title: this.$t('customerUser.dealerGrade'),
          align: 'center',
          slot: 'dealerGrade'
        },
        {
          title: this.$t('customerUser.sale'),
          slot: 'saleName'
        },
        {
          title: this.$t('customerUser.active'),
          slot: 'disable'
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          width: 94
        }
      ]
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    addNew() {
      this.visible_add_new = true
      this.$store.dispatch('security/customerUser/getFormViewModel', {
        index: undefined,
        params: {}
      })
    },
    handleSearchCustomer: debounce(async function(value) {
      this.customer_searching = true
      await this.$store.dispatch('security/customerUser/getFormViewModel', {
        index: 'customers',
        params: {
          fnName: 'customers',
          search_customer: value
        }
      })
      this.customer_searching = false
    }, 800),
    onChangeCustomer(value, option) {
      this.model.user_name = option.data.props.contact_number.replace(
        /\s+/g,
        ''
      )
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('security/customerUser/fetch', attributes)
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    showModal(record) {
      this.model.user_id = record.user_id
      this.visible_resetpwd = true
    },
    closeModal() {
      this.model.user_id = 0
      this.model.customer_id = null
      this.model.user_name = null
      this.model.new_password = null
      this.model.password_confirmation = null
      this.visible_resetpwd = false
      this.visible_add_new = false
      this.errors = new Errors()
    },
    onAddNew() {
      this.waiting = true
      this.$store
        .dispatch('security/customerUser/store', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.closeModal()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    handleOk() {
      this.waiting = true
      this.$store
        .dispatch('security/customerUser/passwordReset', {
          id: this.model.user_id,
          data: this.model
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.closeModal()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.waiting = false
        })
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('security/customerUser/RESET_STATE')
    next()
  }
}
</script>
<style>
.password-icon {
  position: absolute;
  top: 8px;
  right: 10px;
  cursor: pointer;
  color: #6c757d;
}
.password.is-invalid {
  background-image: none;
}
</style>
